import { StepEnum } from '../../../../../components-library/checkout/CheckoutSteps';

export default {
  steps: {
    [StepEnum.OrderConfirmation]: 'Bestelling controleren',
    [StepEnum.OrderPayment]: 'Betaling',
  },
};
